module.exports = __webpack_public_path__ + "static/player-background-5acf2caa426bf1356f11c4b67b57da52.png";